import React, {Component} from "react";
import {connect} from "react-redux";
import {closeContextualMenu} from "../../actions/ViewActions";
import {cx} from "../../lib/ClassSet";
import "./ContextualMenuContainer.css";

function getAnchorX(x, width) {
  if (x < width / 2) return [x, "left"];
  return [width - x, "right"];
}

function getAnchorY(y, height) {
  if (y < height / 2) return [y, "top"];
  return [height - y, "bottom"];
}

class ContextualMenuContainer extends Component {

  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    if (!this.props.active) return null;

    let [x, xAlign] = getAnchorX(this.props.position.get("x"), window.innerWidth);
    let [y, yAlign] = getAnchorY(this.props.position.get("y"), window.innerHeight);

    let modalBlockerClasses = cx({
      "modalBlocker": true,
      "s-active": true
    })
    let menuClasses = cx({
      "menu": true,
      "x-top": yAlign === "top",
      "x-bottom": yAlign === "bottom",
      "x-left": xAlign === "left",
      "x-right": xAlign === "right"
    })
    let menuStyles = {}
    menuStyles[xAlign] = x;
    menuStyles[yAlign] = y;

    let menuElements = this.props.items.map(x => {
      return <Item 
                key={x.get("label")} 
                label={x.get("label")} 
                disabled={x.get("disabled", false)}
                cmd={x.get("cmd")}
                lambda={x.get("lambda")}
                onClick={this.handleItemClick}
                />
    })

    return (
      <div className="ContextualMenuContainer">
        <div className={modalBlockerClasses} onClick={this.props.closeContextualMenu} />
        <div className={menuClasses} style={menuStyles}>
          {menuElements}
        </div>
      </div>
    )
  }

  handleItemClick(cmdOrLambda) {
    this.props.closeContextualMenu();
    if (typeof cmdOrLambda === "function") {
      cmdOrLambda();
    } else {
      this.props.dispatchCommand(cmdOrLambda.toJS());
    }
  }

  handleResize(e) {
    if (this.props.active) {
      this.props.closeContextualMenu();
    }
  }

}

const Item = (props) => {
  let fn = () => props.onClick(props.cmd || props.lambda);
  if (props.disabled) {
    return (
      <div className="item disabled">{props.label}</div>
    )
  }
  
  return (
    <div className="item" onClick={fn}>{props.label}</div>
  )
}

ContextualMenuContainer.defaultProps = {
  active: false
}

const mapDispatchToProps = dispatch => {
  return {
    closeContextualMenu: () => {
      dispatch(closeContextualMenu())
    },
    dispatchCommand: (cmd) => {
      dispatch(cmd);
    }
  }
}

export default connect(null, mapDispatchToProps)(ContextualMenuContainer);